import React from "react"

import Research from "../components/research"
import Layout from "../components/layout"

const ResearchPage = () => {

  return (
    <Layout>
      <Research />
    </Layout>
  )
}

export default ResearchPage